import { EntityConfig, EntityType } from "@/types"
import {
  Box,
  CheckSquare,
  ClipboardList,
  CreditCard,
  FileText,
  History,
  Package,
  Settings,
  Truck,
  Users,
  Wallet,
  Wrench,
} from "lucide-react"

export const HASH_SALT = 10
export const UNDER_DEV = true
export const sessionTimeout = () => {
  if (UNDER_DEV) {
    return 9999 * 60
  } else {
    return 15 * 60
  }
}
export const derbyTurCompany = {
  coordinates: [47.013837, 20.594009]
}
export const SERVICE_SALARY_PER_HOUR = 10000
export const SERVICE_DISTANCE_COST = 300

const RESERVATION_ENABLED = false

export const TIMESLOTS = [
  "08:00-10:00",
  "10:00-12:00",
  "12:00-14:00",
  "14:00-16:00",
  "16:00-18:00",
  "18:00-20:00",
]

export const emailLinkToServiceWorker = process.env.NODE_ENV === 'development' ? 'https://dev.rendiweb.hu' : 'https://rendiweb.hu'


export const fuelPrice = 650

export const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024 // accpeted File size limit

export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
]

export const entityConfigs: Record<EntityType, EntityConfig> = {
  order: {
    type: "order",
    appTitle: "Rendeléskezelő",
    icon: Package,
    tabs: [
      { id: "general", label: "Általános", icon: FileText },
      { id: "customer", label: "Megrendelő", icon: Users },
      { id: "shipping", label: "Szállítás", icon: Truck },
      { id: "items", label: "Tételek", icon: Box },
      {
        id: "payments",
        label: "Fizetés",
        icon: CreditCard,
        requiredRoles: ["admin", "manager"],
      },
      { id: "history", label: "Előzmények", icon: History },
      {
        id: "settings",
        label: "Beállítások",
        icon: Settings,
        requiredRoles: ["admin"],
      },
    ],
  },
  sales: {
    type: "sales",
    appTitle: "Értékesítés",
    icon: Wallet,
    tabs: [],
  },
  shipping: {
    type: "shipping",
    appTitle: "Szállításkezelő",
    icon: Truck,
    tabs: [],
  },
  customer: {
    type: "customer",
    appTitle: "Ügyfélkezelő",
    icon: Users,
    tabs: [],
  },
  picking: {
    type: "picking",
    appTitle: "Picking kezelő",
    icon: ClipboardList,
    tabs: [],
  },

  task: {
    type: "task",
    appTitle: "Feladatkezelő",
    icon: CheckSquare,
    tabs: [],
  },
  service: {
    type: "service",
    appTitle: "Szervíz és Hibajegyek",
    icon: Wrench,
    tabs: [],
  },
}

export const getEntityConfig = (type: EntityType): EntityConfig => {
  return entityConfigs[type]
}

export const UPLOAD_DIRECTORY = "./public"
export const courierMaxLoad = 30


const companyContactPerson = {
  name: 'Kun Péter Ádám',
  email: 'kun-peter@derby-tur.hu',
  phone: '',
  position: ''
}

export const COMPANY = {
  name: 'DerbyTúr Kft.',
  address: '5400 Mezőtúr, Cs. Wágner József u. 28-32',
  phone: '+36 56 354 222',
  serviceCall: '+36 20 440 6290',
  email: 'derby-tur@derby-tur.hu',
  taxNumber: '26091772-2-16',
  companyRegistryNumber: '16-09-017483',
  apiKeyPublic: '',
  contactPerson: companyContactPerson
}


export type PermissionSource =
  | "static"
  | "database"
  | "hybrid";

export const permissionConfig = {
  source: "hybrid" as PermissionSource,
};